import { Component , ChangeDetectionStrategy, OnInit, inject, ChangeDetectorRef, AfterViewInit} from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AccessComponent } from './access/access.component';
import { NewForgotComponent } from './new-forgot/new-forgot.component';
import { RegisterComponent } from './new-register/register.component';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-new-login',
    imports: [CommonModule, TranslateModule, AccessComponent, NewForgotComponent, RegisterComponent],
    templateUrl: './new-login.component.html',
    styleUrl: './new-login.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewLoginComponent implements OnInit, AfterViewInit {

  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private cdr = inject(ChangeDetectorRef);

  currentView: 'access' | 'forgot' | 'register' = 'access';
  private carouselElement: any;

  ngOnInit(): void {
    // Detectar cambios en la URL
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.updateCurrentView(event.url);
        this.cdr.detectChanges(); // Forzar detección de cambios
        // Reiniciar carrusel después del cambio de vista
        setTimeout(() => this.initializeCarousel(), 100);
      });

    // Verificar URL inicial
    this.updateCurrentView(this.router.url);
  }

  ngAfterViewInit(): void {
    // Inicializar carrusel al cargar la vista
    setTimeout(() => this.initializeCarousel(), 100);
  }

  private initializeCarousel(): void {
    this.carouselElement = document.getElementById('carousel');
    if (this.carouselElement && (window as any).bootstrap) {
      // Reinicializar el carrusel de Bootstrap
      const carousel = new (window as any).bootstrap.Carousel(this.carouselElement, {
        interval: 5000,
        pause: false,
        ride: 'carousel'
      });
      carousel.cycle(); // Forzar que continue el ciclo
    }
  }  private updateCurrentView(url: string): void {
    console.log('Actualizando vista para URL:', url);
    if (url.includes('/login/forgot')) {
      this.currentView = 'forgot';
    } else if (url.includes('/login/register')) {
      this.currentView = 'register';
    } else {
      this.currentView = 'access';
    }
    console.log('Vista actual:', this.currentView);
    this.cdr.markForCheck(); // Marcar para revisión en OnPush
  }

}
